<template>
  <v-date-picker
    :is24hr="is24hr"
    :mode="is24hr ? 'dateTime' : mode"
    :value="value"
    is-range
    locale="vi-VN"
    @input="e => $emit('input', e)"
    :attributes="attrs"
    :max-date="maxDate"
    :popover="popover"
    :columns="$screens({ default: 1, lg: 2 })"
  >
    <template v-slot="{ inputValue, inputEvents }">
      <div class="flex justify-center items-center input-clear">
        <input
          readonly
          :value="
            inputValue.start && inputValue.end
              ? `${inputValue.start || '---'} - ${inputValue.end || '---'}`
              : ''
          "
          v-on="inputEvents.start"
          class="form-control f12 hc-37 text-search"
          :placeholder="placeholder"
        />
        <i
          v-if="clearable && value && value.start"
          @click="$emit('input', { start: null, end: null })"
          class="bx bxs-x-circle icon"
        ></i
        ><span>&nbsp;</span>
      </div>
    </template>
  </v-date-picker>
</template>

<script>
  export default {
    props: {
      value: {
        type: Object,
        default() {
          return {
            start: null,
            end: null,
          }
        },
      },
      placeholder: {
        type: String,
        default: '',
      },
      mode: {
        type: String,
        default: 'single',
      },
      clearable: {
        type: Boolean,
        default: false,
      },
      maxDate: {
        type: Date,
        default: null,
      },
      is24hr: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        attrs: [
          {
            key: 'today',
            dot: true,
            dates: new Date(),
          },
        ],
        popover: {
          visibility: 'click',
          positionFixed: true,
        },
      }
    },
  }
</script>

<style scoped>
  .input-clear {
    position: relative;
  }
  .icon {
    position: absolute;
    top: 8px;
    right: 2px;
    font-size: 20px;
    color: #999;
    cursor: pointer;
  }
</style>
